import { Union, Record } from "../fable_modules/fable-library-js.4.29.0/Types.js";
import { bool_type, class_type, union_type, array_type, enum_type, int32_type, getEnumName, record_type, float64_type, uint32_type, string_type } from "../fable_modules/fable-library-js.4.29.0/Reflection.js";
import { map } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { Option_defaultOrMap } from "./Prelude.js";
import { setItem, item, copy, mapIndexed, fill } from "../fable_modules/fable-library-js.4.29.0/Array.js";
import { FSharpSet__Contains, empty } from "../fable_modules/fable-library-js.4.29.0/Set.js";
import { compare } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { min } from "../fable_modules/fable-library-js.4.29.0/Double.js";

export class Fertilizer extends Record {
    constructor(Name, Quality, Speed) {
        super();
        this.Name = Name;
        this.Quality = Quality;
        this.Speed = Speed;
    }
}

export function Fertilizer_$reflection() {
    return record_type("StardewValleyStonks.Fertilizer", [], Fertilizer, () => [["Name", string_type], ["Quality", uint32_type], ["Speed", float64_type]]);
}

export const FertilizerModule_Opt_name = (option) => map((_arg) => _arg.Name, option);

export const FertilizerModule_Opt_quality = (_arg_1) => Option_defaultOrMap(0, (_arg) => _arg.Quality, _arg_1);

export const FertilizerModule_Opt_speed = (_arg_1) => Option_defaultOrMap(0, (_arg) => _arg.Speed, _arg_1);

export function QualityModule_name(quality) {
    return getEnumName(enum_type("StardewValleyStonks.Quality", int32_type, [["Normal", 0], ["Silver", 1], ["Gold", 2], ["Iridium", 3]]), quality);
}

export class Qualities$1 extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["ByQuality"];
    }
}

export function Qualities$1_$reflection(gen0) {
    return union_type("StardewValleyStonks.Qualities`1", [gen0], Qualities$1, () => [[["Item", array_type(gen0)]]]);
}

export const Qualities_zero = new Qualities$1(fill(new Float64Array(4), 0, 4, 0));

export const Qualities_multipliers = new Qualities$1(new Float64Array([1, 1.25, 1.5, 2]));

export function Qualities_indexed(_arg) {
    return mapIndexed((i, x) => [i, x], _arg.fields[0]);
}

export function Qualities_mult(scalar, qualities) {
    const arr = copy(qualities.fields[0]);
    for (let i = 0; i <= 3; i++) {
        setItem(arr, i, scalar * item(i, arr));
    }
    return new Qualities$1(arr);
}

export function Qualities_dot(a, b) {
    let sum = 0;
    for (let i = 0; i <= 3; i++) {
        sum = (sum + (item(i, a.fields[0]) * item(i, b.fields[0])));
    }
    return sum;
}

export class Skill extends Record {
    constructor(Level, Buff) {
        super();
        this.Level = Level;
        this.Buff = Buff;
    }
}

export function Skill_$reflection() {
    return record_type("StardewValleyStonks.Skill", [], Skill, () => [["Level", uint32_type], ["Buff", uint32_type]]);
}

export const SkillModule_zero = new Skill(0, 0);

export function SkillModule_buffedLevel(skill) {
    return skill.Level + skill.Buff;
}

export class Profession extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Tiller", "Artisan", "Agriculturist", "Gatherer", "Botanist"];
    }
}

export function Profession_$reflection() {
    return union_type("StardewValleyStonks.Profession", [], Profession, () => [[], [], [], [], []]);
}

export const ProfessionModule_farmingProfessions = [new Profession(0, []), new Profession(1, []), new Profession(2, [])];

export const ProfessionModule_foragingProfessions = [new Profession(3, []), new Profession(4, [])];

export class Skills extends Record {
    constructor(Farming, Foraging, Professions, IgnoreSkillLevelRequirements, IgnoreProfessionConflicts) {
        super();
        this.Farming = Farming;
        this.Foraging = Foraging;
        this.Professions = Professions;
        this.IgnoreSkillLevelRequirements = IgnoreSkillLevelRequirements;
        this.IgnoreProfessionConflicts = IgnoreProfessionConflicts;
    }
}

export function Skills_$reflection() {
    return record_type("StardewValleyStonks.Skills", [], Skills, () => [["Farming", Skill_$reflection()], ["Foraging", Skill_$reflection()], ["Professions", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [Profession_$reflection()])], ["IgnoreSkillLevelRequirements", bool_type], ["IgnoreProfessionConflicts", bool_type]]);
}

export const SkillsModule_zero = new Skills(SkillModule_zero, SkillModule_zero, empty({
    Compare: compare,
}), false, false);

export function SkillsModule_professionUnlocked(profession, skills) {
    let matchResult;
    if (skills.IgnoreSkillLevelRequirements) {
        matchResult = 0;
    }
    else {
        switch (profession.tag) {
            case 1:
            case 2: {
                matchResult = 2;
                break;
            }
            case 3: {
                matchResult = 3;
                break;
            }
            case 4: {
                matchResult = 4;
                break;
            }
            default:
                matchResult = 1;
        }
    }
    switch (matchResult) {
        case 0:
            return true;
        case 1:
            return skills.Farming.Level >= 5;
        case 2:
            return skills.Farming.Level >= 10;
        case 3:
            return skills.Foraging.Level >= 5;
        default:
            return skills.Foraging.Level >= 10;
    }
}

export function SkillsModule_professionActive(profession, skills) {
    if (SkillsModule_professionUnlocked(profession, skills)) {
        return FSharpSet__Contains(skills.Professions, profession);
    }
    else {
        return false;
    }
}

function SkillsModule_ifElseDistribution(probabilities) {
    const dist = new Float64Array(4);
    let currentProb = 1;
    for (let idx = 0; idx <= (probabilities.length - 1); idx++) {
        const forLoopVar = item(idx, probabilities);
        const prob = currentProb * min(1, forLoopVar[1]);
        setItem(dist, forLoopVar[0], prob);
        currentProb = (currentProb - prob);
    }
    return new Qualities$1(dist);
}

export function SkillsModule_farmCropQualitiesFrom(fertQuality, skills) {
    const buffLevel = SkillModule_buffedLevel(skills.Farming);
    const gold = 0.01 + (0.2 * ((buffLevel / 10) + ((fertQuality * (buffLevel + 2)) / 12)));
    return SkillsModule_ifElseDistribution((fertQuality >= 3) ? [[3, gold / 2], [2, gold], [1, 1]] : [[2, gold], [1, min(2 * gold, 0.75)], [0, 1]]);
}

export function SkillsModule_farmCropProbsWith(fertilizer, skills) {
    return SkillsModule_farmCropQualitiesFrom(FertilizerModule_Opt_quality(fertilizer), skills);
}

export function SkillsModule_forageCropProbs(skills) {
    if (SkillsModule_professionActive(new Profession(4, []), skills)) {
        return new Qualities$1(new Float64Array([0, 0, 0, 1]));
    }
    else {
        const buffLevel = SkillModule_buffedLevel(skills.Foraging);
        return SkillsModule_ifElseDistribution([[2, buffLevel / 30], [1, buffLevel / 15], [0, 1]]);
    }
}

export function SkillsModule_forageCropHarvestQuantities(skills) {
    const probs = SkillsModule_forageCropProbs(skills);
    if (SkillsModule_professionActive(new Profession(3, []), skills)) {
        return Qualities_mult(1.2, probs);
    }
    else {
        return probs;
    }
}

//# sourceMappingURL=Skills.js.map
